export default "__VITE_ASSET__BfFCrYkF__"